import React from 'react';
import './styles/footer.css';

const Footer =function(props){
  return(
      <div className="footer">
        <hr/>
        <div>Charles Brandt © {props.year}</div>
      </div>
  );
}

export default Footer;
